/* esm.sh - applesauce-core@5.2.0/helpers/string */
export * from "/*applesauce-core@5.2.0/esnext/helpers/string.mjs";
